import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { getProductOptions } from '../../api/ProductOption';
import { sharedColors } from '../../utils/Style';

type ProductOption = {
  id: string;
  name: string;
};

type OptionValueDropdownProps = {
  productID: number;
  value?: string;
  onChange: (value?: string) => void;
};

export const OptionValueDropdown = ({
  productID,
  value,
  onChange,
}: OptionValueDropdownProps) => {
  const [options, setOptions] = useState<ProductOption[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshOptions = () => {
    if (productID === 0) {
      setOptions([]);
      return;
    }

    setLoading(true);
    getProductOptions(productID)
      .then((res) => {
        const newOptions = res.options.map((option) => ({
          id:
            productID.toString() +
            option.kvps.map((kvp) => `_${kvp.key}_${kvp.value}`).join(''),
          name: option.kvps.map((kvp) => kvp.value).join(' / '),
        }));

        if (newOptions.length) {
          onChange(newOptions[0].id);
        }

        setOptions(newOptions);
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOptions();
  }, [productID]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        width: '100%',
      }}
    >
      <FormControl size='small' disabled={!options.length} fullWidth>
        <InputLabel>Varyant</InputLabel>

        <Select
          label='Varyant'
          value={value ?? 'NONE'}
          onChange={(e) =>
            onChange(e.target.value === 'NONE' ? undefined : e.target.value)
          }
        >
          {!options.length && (
            <MenuItem value='NONE'>
              <Typography
                sx={{ fontStyle: 'italic', color: sharedColors.gray5 }}
              >
                {'<TÜMÜ>'}
              </Typography>
            </MenuItem>
          )}

          {options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
